import platform from 'platform';
import {
  browserName,
  BrowserTypes,
  browserVersion,
  deviceType,
  fullBrowserVersion,
  getUA,
  isDesktop,
  isEdgeChromium,
  isMobileOnly,
  isTablet,
  osName,
  osVersion,
} from 'react-device-detect';

enum DeviceType {
  Desktop = 'Desktop',
  Tablet = 'Tablet',
  Mobile = 'Mobile',
}

const detectDeviceType = () => {
  switch (true) {
    case isDesktop:
      return DeviceType.Desktop;
    case isTablet:
      return DeviceType.Tablet;
    case isMobileOnly:
      return DeviceType.Mobile;
    default:
      console.warn(`Unexpected device type "${deviceType}" detected.`);

      return deviceType;
  }
};

const detectBrowserName = () => {
  // `browserName` is "Edge" even for Chromium versions. we need this extra check.
  if (isEdgeChromium) {
    return BrowserTypes.EdgeChromium;
  }

  // to be safe, check if the `BrowserTypes` object includes the detected name.
  // but don't warn about WebKit because the test suites use that.
  const isValid = Object.values(BrowserTypes).includes(browserName);
  const isWebKit = browserName === 'WebKit';

  if (!isValid && !isWebKit) {
    console.warn(`Unexpected browser name "${browserName}" detected.`);
  }

  return browserName;
};

const detectOsName = () => {
  // TODO: `react-device-detect` has enum-like objects for browser and os types.
  // they are new additions, and `OsType` seems incomplete:
  // https://github.com/duskload/react-device-detect/pull/134
  // check back later to see if they extended it with the missing OS names.
  // for now, we just send whatever `osName` is without doing a safety check.
  return osName;
};

const detectScreenResolution = () => {
  if (!(window.innerWidth && window.innerHeight)) {
    return null;
  }

  return `${window.innerWidth}:${window.innerHeight}`;
};

const detectFullBrowserVersion = () => fullBrowserVersion;

const detectOsVersion = () => osVersion;

const detectPlatformMake = () => {
  // supposed to detect a lot of manufacturers, see: https://github.com/bestiejs/platform.js/blob/master/platform.js#L1102-L1113
  let result = platform?.manufacturer || null;

  // but it doesn't detect Apple on desktop
  if (!result && osName === 'Mac OS') {
    result = 'Apple';
  }

  return result;
};

const detectPlatformModel = () => {
  // supposed to detect a few products, see: https://github.com/bestiejs/platform.js/blob/master/platform.js#L1139-L1150
  let result = platform?.product || null;

  // but it doesn't detect macs
  if (!result && osName === 'Mac OS') {
    result = 'Mac';
  }

  return result;
};

export {
  browserVersion,
  detectBrowserName,
  detectDeviceType,
  detectFullBrowserVersion,
  detectOsName,
  detectOsVersion,
  detectPlatformMake,
  detectPlatformModel,
  detectScreenResolution,
  getUA as userAgent,
};
